module.exports = __webpack_public_path__ + "media/images/facebook-ed26030ea644014266ff40e0c3986b94.svg";